module.exports = __webpack_public_path__ + "static/media/VanceResume.fe66d0c5.pdf";